var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _g5, _g6, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1253,
    viewBox: "0 0 1440 1253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36_14176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 481,
    y: 185,
    width: 1546,
    height: 923
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1544.82,
    height: 922.064,
    transform: "matrix(-1 0 0 1 2026.2 185)",
    fill: "url(#paint0_radial_36_14176)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36_14176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    width: 128.735,
    height: 128.735,
    transform: "matrix(-1 0 0 1 1065.51 199.483)",
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    width: 128.735,
    height: 128.735,
    transform: "matrix(-1 0 0 1 1319.76 453.734)",
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    width: 128.735,
    height: 128.735,
    transform: "matrix(-1 0 0 1 1065.51 453.734)",
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    width: 128.735,
    height: 128.735,
    transform: "matrix(-1 0 0 1 1446.89 707.985)",
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_36_14176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 481,
    y: 185,
    width: 1546,
    height: 923
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1544.82,
    height: 922.064,
    transform: "matrix(-1 0 0 1 2026.2 185)",
    fill: "url(#paint1_radial_36_14176)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_36_14176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    width: 128.735,
    height: 128.735,
    transform: "matrix(-1 0 0 1 1065.51 199.483)",
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 199.483)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 326.608)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    width: 128.735,
    height: 128.735,
    transform: "matrix(-1 0 0 1 1319.76 453.734)",
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    width: 128.735,
    height: 128.735,
    transform: "matrix(-1 0 0 1 1065.51 453.734)",
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 453.734)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 580.86)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    width: 128.735,
    height: 128.735,
    transform: "matrix(-1 0 0 1 1446.89 707.985)",
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 707.985)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 835.111)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1445.28 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1318.15 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1191.03 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 1063.9 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 936.777 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.804593,
    y: 0.804593,
    width: 127.126,
    height: 127.126,
    transform: "matrix(-1 0 0 1 809.651 962.237)",
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_36_14176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -577,
    y: 185,
    width: 1546,
    height: 923
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -576.395,
    y: 185,
    width: 1544.82,
    height: 922.064,
    fill: "url(#paint2_radial_36_14176)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_36_14176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.289,
    y: 199.483,
    width: 128.735,
    height: 128.735,
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.038,
    y: 453.734,
    width: 128.735,
    height: 128.735,
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.289,
    y: 453.734,
    width: 128.735,
    height: 128.735,
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.91211,
    y: 707.985,
    width: 128.735,
    height: 128.735,
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_36_14176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -577,
    y: 185,
    width: 1546,
    height: 923
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -576.395,
    y: 185,
    width: 1544.82,
    height: 922.064,
    fill: "url(#paint3_radial_36_14176)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_36_14176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.289,
    y: 199.483,
    width: 128.735,
    height: 128.735,
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 200.287,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 327.413,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.038,
    y: 453.734,
    width: 128.735,
    height: 128.735,
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.289,
    y: 453.734,
    width: 128.735,
    height: 128.735,
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 454.539,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 581.664,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.91211,
    y: 707.985,
    width: 128.735,
    height: 128.735,
    fill: "#FF782B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 708.79,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 835.916,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: -123.409,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.7167,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.843,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.969,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.094,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.346,
    y: 963.041,
    width: 127.126,
    height: 127.126,
    stroke: "#FF782B",
    strokeOpacity: 0.3,
    strokeWidth: 1.60919
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_36_14176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 400.064,
    width: 1430,
    height: 452,
    rx: 226,
    fill: "url(#paint4_linear_36_14176)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_36_14176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 487.165,
    width: 880,
    height: 278.128,
    rx: 139.064,
    fill: "url(#paint5_linear_36_14176)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_36_14176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 528.735,
    width: 616,
    height: 194.657,
    rx: 97.3285,
    fill: "url(#paint6_linear_36_14176)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_36_14176",
    x: -395,
    y: 0.0637207,
    width: 2230,
    height: 1252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_36_14176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_36_14176",
    x: -20,
    y: 187.165,
    width: 1480,
    height: 878.128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_36_14176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_36_14176",
    x: 212,
    y: 328.735,
    width: 1016,
    height: 594.657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_36_14176"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_36_14176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(772.409 461.032) rotate(90) scale(568.348 952.207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_36_14176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(772.409 461.032) rotate(90) scale(568.348 952.207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_36_14176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.015 646.032) rotate(90) scale(568.348 952.207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_36_14176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.015 646.032) rotate(90) scale(568.348 952.207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_36_14176",
    x1: 720,
    y1: 400.064,
    x2: 720,
    y2: 852.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#752B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_36_14176",
    x1: 720,
    y1: 487.165,
    x2: 720,
    y2: 765.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#752B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_36_14176",
    x1: 720,
    y1: 528.735,
    x2: 720,
    y2: 723.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#752B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg3);
export default __webpack_public_path__ + "static/media/hero_bg3.8f907a1584973f9c737cf76214fb387a.svg";
export { ForwardRef as ReactComponent };